import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  IconButton,
  Checkbox,
  TextField,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Edit, Delete } from "@material-ui/icons";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import serviciosTablero from "utils/serviciosTablero";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute", // Necesario para centrar el modal en la pantalla
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300, // Asegurarse de que el modal tenga un z-index suficientemente alto
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo oscuro detrás del modal
  },
  colorBox: {
    width: "30px",
    height: "30px",
    borderRadius: "4px",
    margin: "5px",
    cursor: "pointer",
  },
  etiquetaRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "4px",
  },
  colorBox: {
    width: "40px",
    height: "20px",
    borderRadius: "4px",
    marginRight: theme.spacing(2),
  },
  etiquetaName: {
    flex: 1,
  },
}));

const Etiquetas = ({
  tarjeta,
  setCargando,
  setMensaje,
  infoTablero,
  onEtiquetaChange,
  onDeleteEtiqueta,
  onEtiquetaEdit,
}) => {
  const classes = useStyles();
  const [selectedLabels, setSelectedLabels] = useState([]);
  const classesTablero = useStylesTablero();
  const [isCreating, setIsCreating] = useState(false);
  const [editingLabel, setEditingLabel] = useState(null);
  const [newLabel, setNewLabel] = useState({
    idtablero: infoTablero.idtablero,
    nombre: "",
    color: "",
  });
  const [labels, setLabels] = useState([]);
  const colors = [
    "#216E4E",
    "#7F5F01",
    "#A54800",
    "#AE2E24",
    "#09326C",
    "#164555",
    "#4C6B1F",
  ];
  useEffect(() => {
    serviciosTablero.getEtiqueta(
      (status, mensaje, data) => {
        if (status === 1) {
          setLabels(data);
        } else {
          console.error("Error al obtener las etiquetas:", mensaje);
        }
      },
      () => {},
      { idtablero: infoTablero.idtablero }
    );

    serviciosTablero.getEtiquetaTarjeta(
      (status, mensaje, data) => {
        if (status === 1) {
          setSelectedLabels(data.map((etiqueta) => etiqueta.idetiqueta)); // Extrae solo los IDs de las etiquetas seleccionadas
        } else {
          console.error(
            "Error al obtener las etiquetas seleccionadas:",
            mensaje
          );
        }
      },
      setCargando,
      { idtarjeta: tarjeta }
    );
  }, []);

  const handleCheckboxChange = (idetiqueta) => {
    const isSelected = selectedLabels.includes(idetiqueta);

    const updatedSelectedLabels = selectedLabels.includes(idetiqueta)
      ? selectedLabels.filter((id) => id !== idetiqueta) // Deseleccionar
      : [...selectedLabels, idetiqueta];

    setSelectedLabels(updatedSelectedLabels);

    if (isSelected) {
      // Quitar la selección (cambiar estatus de la etiqueta a inactivo)
      serviciosTablero.deleteEtiquetaTarjeta(
        (status, mensaje, data) => {
          if (status === 1) {
            setSelectedLabels((prev) => prev.filter((id) => id !== idetiqueta)); // Actualizar el estado
            onDeleteEtiqueta(data);
            setMensaje({ open: true, status: 1, value: mensaje });
          } else {
            setMensaje({ open: true, status: -1, value: mensaje });
          }
        },
        setCargando,
        { idetiqueta: idetiqueta, idtarjeta: tarjeta, idestatus: 0 }
      );
    } else {
      // Agregar la selección (asociar etiqueta con la tarjeta)
      serviciosTablero.addEtiquetaTarjeta(
        (status, mensaje, data) => {
          if (status === 1) {
            setSelectedLabels((prev) => [...prev, idetiqueta]); // Actualizar el estado
            onEtiquetaChange(data);
            setMensaje({ open: true, status: 1, value: mensaje });
          } else {
            setMensaje({ open: true, status: -1, value: mensaje });
          }
        },
        setCargando,
        { idetiqueta: idetiqueta, idtarjeta: tarjeta }
      );
    }
  };

  const handleSaveNewLabel = () => {
    if (!newLabel.nombre.trim()) {
      setMensaje({
        open: true,
        status: -1,
        value: "El nombre no puede estar vacío",
      });
      return;
    }
    if (!newLabel.color.trim()) {
      setMensaje({
        open: true,
        status: -1,
        value: "El color no puede estar vacío",
      });
      return;
    }
    if (editingLabel) {
      // Actualizar etiqueta existente
      serviciosTablero.editEtiqueta(
        (status, mensaje, data) => {
          if (status === 1) {
            setLabels((prev) =>
              prev.map((label) =>
                label.idetiqueta === newLabel.idetiqueta
                  ? { ...label, ...newLabel }
                  : label
              )
            );
            onEtiquetaEdit(data);
            //Enviar Data a los labels de tarjeta
            setMensaje({
              open: true,
              status: 1,
              value: "Etiqueta actualizada",
            });
            resetForm();
          } else {
            setMensaje({ open: true, status: -1, value: mensaje });
          }
        },
        setCargando,
        newLabel
      );
    } else {
      // Crear nueva etiqueta
      serviciosTablero.addEtiqueta(
        (status, mensaje, data) => {
          if (status === 1) {
            setLabels((prev) => [
              ...prev,
              { ...newLabel, idetiqueta: data.idetiqueta },
            ]);
            setMensaje({ open: true, status: 1, value: "Etiqueta creada" });
            resetForm();
          } else {
            setMensaje({ open: true, status: -1, value: mensaje });
          }
        },
        setCargando,
        newLabel
      );
    }
  };

  const handleEditLabel = (etiqueta) => {
    setEditingLabel(etiqueta);
    setNewLabel(etiqueta);
    setIsCreating(true);
  };

  const handleDeleteLabel = (etiqueta) => {
    serviciosTablero.deleteEtiqueta(
      (status, mensaje, data) => {
        if (status === 1) {
          setLabels((prev) =>
            prev.filter((label) => label.idetiqueta !== data.idetiqueta)
          );
          setSelectedLabels((prev) =>
            prev.filter((id) => id !== data.idetiqueta)
          );
          onDeleteEtiqueta(data);
          setMensaje({ open: true, status: status, value: mensaje });
          setIsCreating(false);
        } else {
          setMensaje({
            open: true,
            status: -1,
            value: "Hubo un problema al eliminar la etiqueta.",
          });
        }
      },
      setCargando,
      { idetiqueta: etiqueta.idetiqueta, idtarjeta: tarjeta }
    );
  };
  const resetForm = () => {
    setNewLabel({
      idtablero: infoTablero.idtablero,
      nombre: "",
      color: colors[0],
    });
    setIsCreating(false);
    setEditingLabel(null);
  };

  // const handleEliminarEtiquetas = () => {
  //   serviciosTablero.deleteEtiqueta(
  //     (status, mensaje, data) => {
  //       if (status === 1) {
  //         setLabels((prev) =>
  //           prev.filter((label) => label.idetiqueta !== newLabel.idetiqueta)
  //         );
  //         setMensaje({ open: true, status: status, value: mensaje });
  //         setIsCreating(false);
  //       } else {
  //         setMensaje({
  //           open: true,
  //           status: -1,
  //           value: "Hubo un problema al eliminar la etiqueta.",
  //         });
  //       }
  //     },
  //     setCargando,
  //     newLabel
  //   );
  // };
  return (
    <Box className={classes.box}>
      {isCreating ? (
        // Formulario para crear o editar etiquetas
        <>
          <Typography variant="h6" gutterBottom>
            {editingLabel ? "Editar Etiqueta" : "Crear Nueva Etiqueta"}
          </Typography>
          <TextField
            label="Nombre de la Etiqueta"
            fullWidth
            variant="outlined"
            value={newLabel.nombre}
            onChange={(e) => {
              const value = e.target.value;
              setNewLabel((prev) => ({ ...prev, nombre: value }));
            }}
            className={classesTablero.field}
            style={{ marginBottom: "16px" }}
            required
          />
          <Autocomplete
            options={colors}
            getOptionLabel={(option) => option} // El código del color como etiqueta
            value={newLabel.color}
            onChange={(event, newValue) =>
              setNewLabel((prev) => ({ ...prev, color: newValue }))
            }
            renderOption={(option) => (
              <Box display="flex" alignItems="center">
                <Box
                  style={{
                    backgroundColor: option,
                    width: 24,
                    height: 24,
                    marginRight: 8,
                    border: "1px solid #ccc",
                  }}
                />
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Color de la Etiqueta"
                variant="outlined"
                fullWidth
                className={classesTablero.field}
                style={{ marginBottom: "16px" }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: newLabel.color && (
                    <Box
                      style={{
                        backgroundColor: newLabel.color,
                        width: 24,
                        height: 24,
                        marginRight: 8,
                        border: "1px solid #ccc",
                      }}
                    />
                  ),
                }}
              />
            )}
          />

          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={handleSaveNewLabel}
            style={{ marginBottom: "16px" }}
          >
            {editingLabel ? "Guardar Cambios" : "Crear"}
          </Button>
          <Button variant="outlined" fullWidth onClick={resetForm} color="secondary">
            Volver a Etiquetas
          </Button>
        </>
      ) : (
        // Lista de etiquetas
        <>
          <div>
            {labels.map((etiqueta) => (
              <div key={etiqueta.idetiqueta} className={classes.etiquetaRow}>
                <Checkbox
                  checked={selectedLabels.includes(etiqueta.idetiqueta)}
                  onChange={() => handleCheckboxChange(etiqueta.idetiqueta)}
                />
                <Box
                  className={classes.colorBox}
                  style={{ backgroundColor: etiqueta.color }}
                />
                <Typography className={classes.etiquetaName}>
                  {etiqueta.nombre}
                </Typography>
                <IconButton
                  color="secondary"
                  onClick={() => handleEditLabel(etiqueta)}
                  title="Editar"
                >
                  <Edit />
                </IconButton>
                <IconButton
                  style={{ color: "#e57373" }}
                  onClick={() => handleDeleteLabel(etiqueta)}
                  title="Eliminar"
                >
                  <Delete />
                </IconButton>
              </div>
            ))}
          </div>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={() => setIsCreating(true)}
            style={{ marginTop: "16px" }}
          >
            Crear Nueva Etiqueta
          </Button>
        </>
      )}
    </Box>
  );
};

export default Etiquetas;
